export default __webpack_public_path__ + "static/media/logo.f11ff4fb.svg";